// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Browser__Tabs$SmartcutsMacros = require("./Browser__Tabs.bs.js");

function getActiveTabOfLastFocusedWindow(param) {
  return Browser__Tabs$SmartcutsMacros.query({
                active: true,
                lastFocusedWindow: true
              }).then(function (results) {
              return Promise.resolve(Belt_Option.map(Belt_Array.get(results, 0), Browser__Tabs$SmartcutsMacros.Tab.fromJs));
            });
}

function getActiveTabOfCurrentWindow(param) {
  return Browser__Tabs$SmartcutsMacros.query({
                active: true,
                currentWindow: true
              }).then(function (tabs) {
              var tabWithStringStatus = Belt_Array.get(tabs, 0);
              if (tabWithStringStatus === undefined) {
                return Promise.resolve(undefined);
              }
              var tab = Browser__Tabs$SmartcutsMacros.Tab.fromJs(Caml_option.valFromOption(tabWithStringStatus));
              return Promise.resolve(tab);
            });
}

function findTabsWithFirstMatchingUrlPattern(urlPatterns) {
  if (!urlPatterns) {
    return Promise.resolve([]);
  }
  var remainingUrlPatterns = urlPatterns.tl;
  return Browser__Tabs$SmartcutsMacros.query({
                url: [urlPatterns.hd]
              }).then(function (tabsWithStringStatus) {
              if (tabsWithStringStatus.length !== 0) {
                return Promise.resolve(tabsWithStringStatus);
              } else {
                return findTabsWithFirstMatchingUrlPattern(remainingUrlPatterns);
              }
            });
}

exports.getActiveTabOfLastFocusedWindow = getActiveTabOfLastFocusedWindow;
exports.getActiveTabOfCurrentWindow = getActiveTabOfCurrentWindow;
exports.findTabsWithFirstMatchingUrlPattern = findTabsWithFirstMatchingUrlPattern;
/* Browser__Tabs-SmartcutsMacros Not a pure module */
